module.exports = __webpack_public_path__ + "static/media/btn_plus.2b32802f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/btn_plus.svg
// module id = 1096
// module chunks = 0